<template>
  <div class="personnel-decoration">
    <Personnel_decoration v-if="String(editpersonnel_temporary.id_card).length > 11" :editpersonnel_temporary="editpersonnel_temporary" />
  </div>
</template>

<script>
import Personnel_decoration from '../../components/college/personnel_decoration.vue';
export default {
  components: {
    Personnel_decoration
  },
  data() {
    return {
      ApiKey: "HRvec2021",
      editpersonnel_temporary:[],
    };
  },

  mounted() {
    this.loadUserData();
  },

  methods: {
      async loadUserData() {
      try {
        this.loading = true;
        const userSession = JSON.parse(localStorage.getItem("user")) || {};

        const result = await this.$http.post("personnel_temporary.php", {
          ApiKey: this.ApiKey,
          id_card: userSession.id_card
        });

        this.editpersonnel_temporary = result.data || {};
      } catch (error) {
        console.error("Error loading user data:", error);
        this.$toast.error("เกิดข้อผิดพลาดในการโหลดข้อมูล");
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>


<style scoped>
.personnel-decoration {
  padding: 20px;
}
</style>
